module.exports = __webpack_public_path__ + "static/media/1start.485f9c5e.png";